import script from "./CancelOrderModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CancelOrderModal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__